// Labels for different permissions in Arabic
export const permissionsLabels = {
  // Projects & verification
  viewProjects: "عرض المشاريع",
  editProjects: "تحرير المشاريع",
  showGiftProject: "عرض الإهداءات",
  editGiftProject: "تحرير الإهداءات",
  canDoProjectVerification: "توثيق المشاريع",
  verificationManager: "مدير التوثيق",

  // Donations & finance
  viewDonations: "عرض التبرعات",
  coordinatorDonations: "تبرعات المنسقين",
  financialSupervisorReport: "التقرير المالي",
  abandonedCarts: "عرض السلات المتروكة",

  // Marketing & campaigns
  sendMessage: "إرسال رسالة",
  editSmsMessage: "التحكم في الرسائل",
  customerCampaigns: "حملات المتبرعين",
  whatsappCampaign: "حملات الواتساب",
  advertisementLinks: "روابط المسوقين",
  advertisementCoordinators: "منسقو التسويق",
  // matrixAds: "إعلانات ماتريكس", // معطّل مؤقتًا حتى يتم تفعيل المنصة

  // Customers & engagement
  donors: "عرض المتبرعين",
  ratings: "إدارة التقييمات",
  viewComplaintsAndSuggestions: "الشكاوى والاقتراحات",

  // Reports & statistics
  statistics: "عرض الإحصائيات",
  requiredReports: "تقرير التبرعات التفصيلي",
  nationalCenterReport: "تقارير المركز الوطني",
  exportData: "تصدير البيانات",
  importData: "استيراد البيانات",
  showLogs: "سجل الأحداث",

  // Site content
  viewSitePages: "عرض صفحات الموقع",
  editSitePages: "تحرير صفحات الموقع",
  viewMainBanner: "عرض البانر الرئيسي",
  editMainBanner: "تحرير البانر الرئيسي",
  homepageSettings: "إعدادات الصفحة الرئيسية",
  // arrangeHomepageItems: "ترتيب عناصر الصفحة الرئيسية", // معطّل مؤقتًا
  // popups: "إدارة النوافذ المنبثقة", // معطّل مؤقتًا
  ourPartners: "إدارة الشركاء",

  // Themes
  viewThemes: "عرض الثيمات",
  editThemes: "تحرير الثيمات",
  publishThemes: "نشر الثيمات",

  // Settings & system
  generalSettings: "الإعدادات العامة",
  associationData: "عرض بيانات الجمعية",
  editAssociationData: "تحرير بيانات الجمعية",
  serviceLinkSettings: "إعدادات التكاملات الخارجية",
  permissions: "الموظفون والصلاحيات",
  // showNotifications: "عرض الإشعارات", // معطّل مؤقتًا
};

// Detailed descriptions shown under each permission label in the UI.
// Separate map so existing consumers of permissionsLabels stay unchanged.
// Format: 2 short sentences explaining what the permission allows + concrete examples / boundaries.
export const permissionsDescriptions = {
  // Projects & verification
  viewProjects:
    "الاطلاع على قائمة جميع المشاريع المنشورة وغير المنشورة مع كافة تفاصيلها (الصور، الوصف، المبالغ المستهدفة، نسب الإنجاز). صلاحية قراءة فقط دون إمكانية الإضافة أو التعديل أو الحذف.",
  editProjects:
    "إنشاء مشاريع جديدة وتعديل المشاريع القائمة بالكامل: الاسم، الصور، الوصف، المبلغ المستهدف، تواريخ البدء والانتهاء. يشمل تفعيل المشاريع وإيقافها وأرشفتها.",
  showGiftProject:
  "الاطلاع على قائمة جميع الإهداءات المنشورة وغير المنشورة مع كافة تفاصيلها (الصور، الوصف، المبالغ المستهدفة). صلاحية قراءة فقط دون إمكانية الإضافة أو التعديل أو الحذف.",
  editGiftProject:
  "إنشاء إهداءات جديدة وتعديل الإهداءات القائمة بالكامل: الاسم، الصور، الوصف، المبلغ المستهدف. يشمل تفعيل الإهداءات وإيقافها وأرشفتها.",
  canDoProjectVerification:
    "تنفيذ عمليات التوثيق للتبرعات: مراجعة الوسائط، الموافقة أو الرفض مع توضيح السبب، وإرفاق ملاحظات للمندوب لتعديل التوثيق.",
  verificationManager:
    "الإشراف الكامل على فريق التوثيق: مراجعة قرارات الموثقين، إعادة اسناد الطلبات والاطلاع على إحصائيات الأداء الفردي والجماعي والتقارير الدورية للفريق.",

  // Donations & finance
  viewDonations:
    "الاطلاع على جميع التبرعات الواردة من كافة القنوات (الموقع، المنسقين، التحويل البنكي) مع بيانات المتبرع والمبلغ والمشروع وطريقة الدفع وحالة التبرع.",
  coordinatorDonations:
    "عرض التبرعات الواردة عبر روابط الإحالة الخاصة بالمسوقين والمنسقين، مع تحديد المنسق المسؤول عن كل تبرع .",
  financialSupervisorReport:
    "الاطلاع على التقرير المالي الموحد للجمعية: إجمالي الإيرادات حسب المشروع والقناة والفترة الزمنية، مع التدفقات النقدية اليومية والشهرية وملخصات الأداء المالي.",
  abandonedCarts:
    "متابعة المتبرعين الذين بدأوا عملية التبرع ولم يكملوها، مع تفاصيل المبلغ المختار والمشروع ووقت ترك السلة. يساعد على إستهدافهم لاستكمال التبرع.",

  // Marketing & campaigns
  sendMessage:
    "إرسال رسائل مباشرة عبر الرسائل النصية لمتبرع واحد أو مجموعة محددة. يستخدم للتواصل الفردي السريع خارج نطاق الحملات المجدولة.",
  editSmsMessage:
    "إدارة قوالب الرسائل التلقائية التي يرسلها النظام (تأكيد التبرع، الشكر، التذكير، إيصالات الدفع) عبر الرسائل النصية، مع تخصيص النصوص لكل حدث.",
  customerCampaigns:
    "إدارة الحملات التي يتم طلبها من خلال المتبرعين و ذلك لعمل مشروع حسب الطلب.",
  whatsappCampaign:
    "إنشاء وإرسال حملات تسويقية عبر الواتساب باستخدام قوالب معتمدة .",
  advertisementLinks:
    "إنشاء روابط إحالة مخصصة للمسوقين، تتبع التبرعات الواردة عبر كل رابط، عرض إحصائيات الزيارات والتحويلات.",
  advertisementCoordinators:
    "إضافة وإدارة حسابات منسقي التسويق.",
  // matrixAds: "ربط وإدارة الحملات على منصة ماتريكس الإعلانية", // معطّل

  // Customers & engagement
  donors:
    "الاطلاع على قاعدة بيانات المتبرعين كاملة: البيانات الشخصية، سجل التبرعات، إجمالي مبالغ التبرع، المشاريع المدعومة، وتاريخ آخر تبرع لكل متبرع.",
  ratings:
    "عرض تقييمات وآراء المتبرعين و مدي رضا المتبرعين عن عملية التبرع.",
  viewComplaintsAndSuggestions:
    "الاطلاع على الشكاوى والاقتراحات الواردة من الزوار والمتبرعين، تصنيفها حسب النوع، والرد عليها مباشرة من النظام.",

  // Reports & statistics
  statistics:
    "الاطلاع على لوحة الإحصائيات الرئيسية: إجمالي التبرعات، عدد المتبرعين، نسب إنجاز المشاريع، أكثر القنوات تبرعًا، والمقارنات الزمنية بين الفترات.",
  requiredReports:
    "تجهيز وتصدير تقرير تفصيلي بجميع التبرعات خلال فترة محددة، يتضمن بيانات المتبرع الكاملة والمبلغ والمشروع وطريقة الدفع.",
  nationalCenterReport:
    "تجهيز التقارير الدورية المطلوبة من المركز الوطني لتنمية القطاع غير الربحي بالصيغة المعتمدة رسميًا، وتصديرها بصيغة جاهزة للرفع على بوابة المركز.",
  exportData:
    "تنزيل بيانات النظام (المتبرعين، التبرعات، المشاريع، التقارير المالية) بصيغة Excel أو CSV للتحليل الخارجي أو الأرشفة أو المشاركة مع جهات شريكة.",
  importData:
    "رفع بيانات جماعية من ملفات Excel أو CSV (قوائم المتبرعين، التبرعات السابقة، بيانات المشاريع) ودمجها في النظام مع التحقق التلقائي من صحة البيانات وتنبيه عن الأخطاء.",
  showLogs:
    "الاطلاع على سجل النشاطات الكامل للنظام: من قام بأي إجراء (إنشاء، تعديل، حذف، تسجيل دخول، تغيير صلاحيات) ووقت تنفيذه. يستخدم لأغراض المراجعة والتدقيق الأمني.",

  // Site content
  viewSitePages:
    "الاطلاع على صفحات الموقع التعريفية الثابتة (من نحن، تواصل معنا، الأسئلة الشائعة) وصفحات الهبوط الترويجية، مع عرض المحتوى الحالي دون إمكانية التعديل.",
  editSitePages:
    "تعديل محتوى صفحات الموقع التعريفية وصفحات الهبوط: تغيير النصوص، الصور، روابط الأزرار، وعناصر التصميم. التغييرات تنعكس مباشرة على الموقع المنشور.",
  viewMainBanner:
    "الاطلاع على بانرات الصفحة الرئيسية النصوص والصور و العرض. صلاحية قراءة فقط دون تعديل.",
  editMainBanner:
    "إضافة وتعديل بانرات الصفحة الرئيسية: تغيير الصور والنصوص الترويجية، وتفعيلها أو إيقافها حسب الحاجة.",
  homepageSettings:
    "التحكم في البنرين في الصفحة الرئيسية للموقع وتفعيل أو إخفاء كل قسم على حدة.",
  // arrangeHomepageItems: "إعادة ترتيب الأقسام الظاهرة في الصفحة الرئيسية", // معطّل مؤقتًا
  // popups: "إنشاء وعرض النوافذ المنبثقة الترويجية على الموقع", // معطّل مؤقتًا
  ourPartners:
    "إضافة وتعديل وحذف قائمة الشركاء والداعمين الظاهرين في الصفحة الرئيسية، مع شعار كل شريك ورابط موقعه الإلكتروني وترتيب ظهوره.",

  // Themes
  viewThemes:
    "الاطلاع على قائمة الثيمات (التصاميم) المتوفرة للموقع، معاينة كل ثيم قبل تطبيقه، ورؤية الثيم النشط حاليًا للزوار. صلاحية قراءة فقط دون تعديل أو نشر.",
  editThemes:
    "إنشاء ثيمات جديدة وتعديل الثيمات القائمة: تغيير الألوان، الخطوط، الأيقونات، تخطيط الصفحات، ومعاينة التغييرات بشكل مباشر قبل اعتمادها للنشر.",
  publishThemes:
    "تفعيل ثيم محدد ليصبح التصميم قابل للاستخدام.",

  // Settings & system
  generalSettings:
    "ضبط الإعدادات العامة للمنصة: شعار المنصة، تفعيل التبرع السريع، تحديد الحد الأدنى لإجمالي التبرعات، و غيرها.",
  associationData:
    "الاطلاع على بيانات الجمعية: الاسم ، العنوان، أرقام التواصل، البريد الإلكتروني، وروابط شبكات التواصل الاجتماعي الظاهرة في الموقع.",
  editAssociationData:
    "تعديل البيانات التعريفية للجمعية: الاسم ، العنوان، أرقام التواصل، البريد الإلكتروني، وروابط شبكات التواصل الاجتماعي الظاهرة في الموقع.",
  serviceLinkSettings:
    "ربط النظام  وأدوات التحليل الخارجية.",
  permissions:
    "إضافة موظفي المتجر وتعديل بياناتهم، تحديد صلاحياتهم بدقة عبر مجموعات الصلاحيات، وإيقاف أو حذف الحسابات. هذه الصفحة الحالية التي تستخدمها الآن.",
  // showNotifications: "الاطلاع على إشعارات النظام والأحداث المهمة", // معطّل مؤقتًا
};

// Default values for permissions (all set to false)
export const permissionsValues = Object.keys(permissionsLabels).reduce(
  (acc, key) => {
    acc[key] = false;
    return acc;
  },
  {},
);

// Mapping of permission types to their respective permissions
export const permissionsMappingObject = {
  1: [
    "ratings",
    // "matrixAds", // معطّل مؤقتًا
    "editProjects",
    "viewProjects",
    "editSitePages",
    "editMainBanner",
    "editGiftProject",
    "showGiftProject",
    "generalSettings",
    "associationData",
    "homepageSettings",
    // "arrangeHomepageItems", // معطّل مؤقتًا
    "advertisementCoordinators",
  ], // مدير المشاريع
  2: ["financialSupervisorReport"], // المدير المالي
  3: ["abandonedCarts", "advertisementLinks"], // خدمة العملاء و التسويق بالواتساب
  4: ["advertisementLinks", "serviceLinkSettings"], // المسوقين
  5: ["canDoProjectVerification", "verificationManager"], // خدمات التوثيق
  6: [],
};

// List of permission types with their names and values
export const permissionsTypes = [
  { name: "المشرف العام", value: 0 },
  { name: "مدير المشاريع", value: 1 },
  { name: "المدير المالي", value: 2 },
  { name: "خدمة العملاء و التسويق بالواتساب", value: 3 },
  { name: "المسوقين", value: 4 },
  { name: "خدمات التوثيق", value: 5 },
  { name: "خاص", value: 6 },
];

// Permission groups for UI display.
// Each group has a one-line `description` rendered under its title.
export const permissionGroups = [
  {
    name: "المشاريع والتوثيق",
    description: "إدارة المشاريع والإهداءات وعمليات التحقق منها",
    keys: [
      "viewProjects",
      "editProjects",
      "showGiftProject",
      "editGiftProject",
      "canDoProjectVerification",
      "verificationManager",
    ],
  },
  {
    name: "التبرعات والمالية",
    description: "متابعة التبرعات الواردة والتقارير المالية والسلات المتروكة",
    keys: [
      "viewDonations",
      "coordinatorDonations",
      "financialSupervisorReport",
      "abandonedCarts",
    ],
  },
  {
    name: "التسويق والحملات",
    description: "إدارة حملات التسويق والرسائل وروابط المسوقين",
    keys: [
      "sendMessage",
      "editSmsMessage",
      "customerCampaigns",
      "whatsappCampaign",
      "advertisementLinks",
      "advertisementCoordinators",
      // "matrixAds", // معطّل مؤقتًا
    ],
  },
  {
    name: "العملاء والتفاعل",
    description: "إدارة المتبرعين والتفاعل مع زوار الموقع",
    keys: ["donors", "ratings", "viewComplaintsAndSuggestions"],
  },
  {
    name: "التقارير والإحصائيات",
    description: "الاطلاع على التقارير وتصدير البيانات وسجل الأحداث",
    keys: [
      "statistics",
      "requiredReports",
      "nationalCenterReport",
      "exportData",
      "importData",
      "showLogs",
    ],
  },
  {
    name: "محتوى الموقع",
    description: "تحرير صفحات الموقع والبانرات والنوافذ المنبثقة والشركاء",
    keys: [
      "viewSitePages",
      "editSitePages",
      "viewMainBanner",
      "editMainBanner",
      "homepageSettings",
      // "arrangeHomepageItems", // معطّل مؤقتًا
      // "popups", // معطّل مؤقتًا
      "ourPartners",
    ],
  },
  {
    name: "الثيمات",
    description: "إنشاء ثيمات الموقع وتعديلها ونشرها للزوار",
    keys: ["viewThemes", "editThemes", "publishThemes"],
  },
  {
    name: "الإعدادات والنظام",
    description: "إعدادات النظام وبيانات الجمعية والتكاملات والصلاحيات",
    keys: [
      "generalSettings",
      "associationData",
      "editAssociationData",
      "serviceLinkSettings",
      "permissions",
      // "showNotifications", // معطّل مؤقتًا
    ],
  },
];

// Function to fill a form with permission data
export const permissionsFillForm = (data) => {
  return Object.keys(permissionsLabels).reduce((acc, key) => {
    acc[key] = data[key];
    return acc;
  }, {});
};
